<app-simple-modal-header
	[pageTitle]="pageTitle"
	(dismissed)="dismiss()"
></app-simple-modal-header>

<ion-content>
	<form [formGroup]="addAttachmentForm" (ngSubmit)="onAddAttachment()">
		<ion-list lines="full" mode="md">
			<ion-item>
				<ion-input
					#fileInputEl
					name="attachment"
					type="file"
					(change)="attachFile($event.target.files)"
					[accept]="validExtensions"
					[hidden]="true"
				></ion-input>
				<ion-button
					color="primary"
					size="default"
					(click)="onClickTriggerNativeInput()"
				>
					Choose File
				</ion-button>
				<ion-label *ngIf="filename" class="chosen-file">
					{{ filename }}
				</ion-label>
			</ion-item>
			<ion-item>
				<ion-label>Filename: </ion-label>
				<ion-input
					#filenameInputEl
					formControlName="filename"
					name="filename"
					type="text"
					autofocus="true"
					maxlength="250"
				></ion-input>
			</ion-item>
			<ion-item *ngIf="!isFormValid">
				<ion-label class="ion-text-center" color="danger">
					All fields are required
				</ion-label>
			</ion-item>
		</ion-list>
		<ion-button expand="full" type="submit">
			Add Attachment
		</ion-button>
	</form>
</ion-content>
